import { FsLprAxonVIFilterSuggestion, FsLprAxonVIRead } from '../models';
import { LPRResultsFacets } from './common/lpr-results-facets';

export interface FsLprAxonVIResults {
  data: FsLprAxonVIRead[];
  metadata: {
    total: number;
    totalQueryResults: number;
    facets?: LPRResultsFacets;
  };
}

export interface FsLprAxonVIFilterSuggestionResults {
  data: FsLprAxonVIFilterSuggestion[];
  metadata: {
    total: number;
    totalQueryResults: number;
  };
}
